// extracted by mini-css-extract-plugin
export var compactFilters = "_cc-4";
export var detailImage = "_cc-1";
export var dropdownContainer = "_cc-2";
export var imageContainer = "_cc-0";
export var selectedCard = "_cc-3";